import React from 'react';
import { Svg } from 'components/icons/Svg';

export const IconTasklist20 = props => (
  <Svg {...props} viewBox="0 0 20 20">
    <path
      d="M15 6l-6.5 7L6 10"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);
